var map = {
	"./analiza-fundamentalna.md": [
		"300a",
		"chunk-2d0b8a44"
	],
	"./analiza-techniczna.md": [
		"e248",
		"chunk-2d224ca7"
	],
	"./broker.md": [
		"8762",
		"chunk-2d0deaf1"
	],
	"./cfd.md": [
		"1010",
		"chunk-2d0aa174"
	],
	"./day-trading.md": [
		"b4d7",
		"chunk-2d20fcdb"
	],
	"./dzwignia.md": [
		"998b",
		"chunk-2d0e6740"
	],
	"./etf.md": [
		"d915",
		"chunk-2d21f22f"
	],
	"./fed.md": [
		"2bee",
		"chunk-2d0bd806"
	],
	"./forex.md": [
		"7814",
		"chunk-2d0d79ba"
	],
	"./gpw.md": [
		"405f",
		"chunk-2d0bff43"
	],
	"./indeks-gieldowy.md": [
		"9e2d",
		"chunk-2d0f0bb4"
	],
	"./konto-demo.md": [
		"77ef",
		"chunk-2d0d7c77"
	],
	"./kontrakt-terminowy.md": [
		"a233",
		"chunk-2d207b07"
	],
	"./kryptowaluty.md": [
		"912f",
		"chunk-2d0e4882"
	],
	"./kryzys-finansowy.md": [
		"c06a",
		"chunk-2d215cce"
	],
	"./lot.md": [
		"6d3f",
		"chunk-2d0daaf7"
	],
	"./margin-call.md": [
		"2f1b",
		"chunk-2d0be0bb"
	],
	"./maszyna-wirtualna.md": [
		"359a",
		"chunk-2d0b9e20"
	],
	"./pkc.md": [
		"e35a",
		"chunk-2d2250b0"
	],
	"./platforma-transakcyjna.md": [
		"cc03",
		"chunk-2d221b59"
	],
	"./pozycja-dluga.md": [
		"131f",
		"chunk-2d0aaced"
	],
	"./pozycja-krotka.md": [
		"5b7f",
		"chunk-2d0d2f92"
	],
	"./quantitative-easing.md": [
		"e3b7",
		"chunk-2d2255f9"
	],
	"./rolowanie-kontraktow.md": [
		"4151",
		"chunk-2d0c02cf"
	],
	"./social-trading.md": [
		"7de3",
		"chunk-2d0e2531"
	],
	"./spread.md": [
		"8531",
		"chunk-2d0de311"
	],
	"./stop-loss.md": [
		"e729",
		"chunk-2d225f2f"
	],
	"./stopy-procentowe.md": [
		"3e4e",
		"chunk-2d0c51b9"
	],
	"./take-profit.md": [
		"3243",
		"chunk-2d0b9214"
	],
	"./zabezpieczenie-depozytow.md": [
		"4f05",
		"chunk-2d0cc92d"
	],
	"./zabezpieczenie-przed-saldem-ujemnym.md": [
		"e6a7",
		"chunk-2d22611d"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "dc09";
module.exports = webpackAsyncContext;